<template>
  <div :class="$style.app">
    <header :class="$style.header">
      <div :class="$style.header__main">
        <div :class="$style.language">
          <span :class="getLanguageClass('de')" @click="selectLanguage('de')">DE</span>
          <span :class="getLanguageClass('en')" @click="selectLanguage('en')">EN</span>
        </div>
        <img width="686" height="184" :class="$style.header__logo" @click="gotoStart" src="@/assets/logo.svg" alt="">
      </div>
    </header>
    <div :class="$style.header__title">
      <transition name="main-transition">
        <span :key="title">{{ title }}</span>
      </transition>
    </div>
    <main :class="$style.body">
      <transition name="main-transition">
        <router-view :class="$style.router"/>
      </transition>
    </main>
    <div :class="$style.status_screen"></div>
  </div>
</template>

<script type="text/babel">
export default {
  computed: {
    title() {
      return this.$t(this.$route.meta.title, this.$route.meta.options);
    },
  },
  methods: {
    getLanguageClass(locale) {
      return locale === this.$i18n.locale ? this.$style.language_active : null;
    },
    gotoStart() {
      this.$router.push('/');
    },
    selectLanguage(locale) {
      this.$i18n.locale = locale;
    },
  },
};
</script>

<style src="@/scss/global.scss" lang="scss"></style>

<style lang="scss" module>
  /* Autorotate to Portrait Mode */
  @media only screen and (min-aspect-ratio: 1/1){
    html {
      transform: rotateZ(90deg);
      transform-origin: calc(100vw / 2) center;
      width: 100vh!important;
      height: 100vw!important;
    }
  }
  html, body {
    padding: 0;
    margin: 0;
    overflow: hidden;
    font-family: Ubuntu, sans-serif;
    width: 100%;
    height: 100%;
    font-size: 1.2em;
  }
  .app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .language {
    display: flex;
    align-items: center;
    &_active {
      font-weight: 600;
      color: var(--primary)
    }
    span {
      padding: 1em;
    }
  }
  .header {
    z-index: 1;

    /*margin-bottom: 1em;*/
    &__main {
      background: #fff;
      z-index: 10;
      display: flex;
      justify-content: space-between;
    }
    &__logo {
      --width: 17.5em;
      width: var(--width);
      height: calc(var(--width) * (184 / 684));
      margin-bottom: -1em;
    }
    &__title {
      background: linear-gradient(to top, rgba(0,0,0,0), rgba(0, 0, 0, 0.3)), var(--primary);
      color: #fff;
      padding: .6em;
      text-align: left;
      font-size: 1.25em;
      height: 1.2em;
      line-height: 1.2;
    }
  }
  .body {
    flex-grow: 1;
    position: relative;
  }
  .router {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .main-transition {
    &-enter-active, &-leave-active {
      transition: opacity .7s, transform .9s;
      position: absolute;
    }
    &-enter, &-leave-to {
      opacity: 0;
    }
    &-enter {
      transform: translateX(50%);
    }
    &-leave-to {
      transform: translateX(-20%);
      transition: opacity .3s, transform .5s;
    }
  }
</style>
